import {FileItem, FileUploader, FileUploaderOptions, ParsedResponseHeaders} from "ng2-file-upload";
import {Subject} from "rxjs/Subject";
import {Observable} from "rxjs/Observable";


export class NvFileUploader extends FileUploader {
  private _onCompleteSubject: Subject<any> = new Subject();
  private _onErrorSubject: Subject<string> = new Subject();


  constructor(options: FileUploaderOptions) {
    super(options);
  }


  public get onComplete(): Observable<any> {
    return this._onCompleteSubject.asObservable();
  }


  public get onError(): Observable<any> {
    return this._onErrorSubject.asObservable();
  }


  onSuccessItem(item: FileItem,
                response: string,
                status: number,
                headers: ParsedResponseHeaders): any {
    this._onCompleteSubject.next(void 0);
    return super.onSuccessItem(item, response, status, headers);
  }


  onErrorItem(item: FileItem,
              response: string,
              status: number,
              headers: ParsedResponseHeaders): any {
    this._onErrorSubject.next(response);
    return super.onErrorItem(item, response, status, headers);
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/classes/nv-file-uploader/nv-file-uploader.class.ts